import React from 'react';
import PropTypes from 'prop-types';

import { Dialog as MUIDialog } from '@mui/material';

export const Dialog = ({ disableBackdropClick, disableEscapeKeyDown, onClose, ...props }) => (
  <MUIDialog
    {...props}
    onClose={(event, reason) => {
      if (disableBackdropClick && reason === 'backdropClick') {
        return;
      }
      // v9 removed disableEscapeKeyDown entirely (same way v5 removed disableBackdropClick) —
      // reimplemented the same way: no-op onClose for that specific reason instead.
      if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
        return;
      }
      if (onClose) {
        onClose(event, reason);
      }
    }}
  />
);

Dialog.propTypes = {
  PaperProps: PropTypes.object,
  TransitionComponent: PropTypes.elementType,
  TransitionProps: PropTypes.object,
  classes: PropTypes.object,
  disableBackdropClick: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  fullScreen: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  scroll: PropTypes.oneOf(['body', 'paper'])
};

export default Dialog;
